import { render, staticRenderFns } from "./ProjectWebsiteEdit.vue?vue&type=template&id=bfb6f1c4"
import script from "./ProjectWebsiteEdit.vue?vue&type=script&lang=ts"
export * from "./ProjectWebsiteEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports